"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _remark = _interopRequireDefault(require("remark"));

var _stripMarkdown = _interopRequireDefault(require("strip-markdown"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable no-sync */


var remarkStripMarkdown = function remarkStripMarkdown(text) {
  var stripped = (0, _remark.default)().use(_stripMarkdown.default).processSync(text);
  return stripped;
};

remarkStripMarkdown.propTypes = {
  text: _propTypes.default.string.isRequired
};
var _default = remarkStripMarkdown;
exports.default = _default;